export default __webpack_public_path__ + "static/media/gorilla-glue-funky.3bbd1be0.png";